import axios from "axios";
import { CompanyAssociationInfoRequestModel, PrivateUserInfoRequestModel, UserInfosModel } from "../../models/user/UserInfosModel";
import httpClient from "../../utilities/http-client";
import settings from "../../utilities/settings";
import { ExistPendingCloseAccountResponse } from "../../models/responses/ExistPendingCloseAccountResponse";
import { CloseUserAccountResponse } from "../../models/responses/CloseUserAccountResponse";
import { ConfirmOrRejectCloseUserAccountRequest } from "../../models/requests/ConfirmOrRejectCloseUserAccountRequest";
import { ConfirmOrRejectCloseUserAccountResponse } from "../../models/responses/ConfirmOrRejectCloseUserAccountResponse";

export const checkUserAuth = async () => {
	try {
		const { data } = await httpClient.get(`/users/check-auth`);
		return data;
	} catch (e:any) {
		throw e;
	}
};

export const fetchMe = async () => {
	try {
		const { data } = await httpClient.get<UserInfosModel>(`/users/me`);
		return data;
	} catch (e:any) {
		throw e;
	}
};

export const putMePrivate = async (model: PrivateUserInfoRequestModel) => {
	try {
		const { data } = await httpClient.put<PrivateUserInfoRequestModel>(`/users/me`, model);
		return data;
	} catch (e:any) {
		throw e;
	}
};

export const putMeAssociationOrCompany = async (model:CompanyAssociationInfoRequestModel) => {
	try {
		const { data } = await httpClient.put<CompanyAssociationInfoRequestModel>(`/users/company/me`, model);
		return data;
	} catch (e:any) {
		throw e;
	}
};

export const nationsList = async () => {
	try {
		const httpClientIdentity = axios.create({
			baseURL: settings.Domains.IdentityApi+'/api/',
			headers: {
				"content-type": "application/json",
			},
			responseType: "json",
			withCredentials: true 
		});
		const { data } = await httpClientIdentity.get("/nations/list");
		return data;
	} catch (e: any) {
		throw e?.message || e || "exception during request associations list";
	}
}

// Iniziato a pulire il codice sia lato BE che FE
export const existPendingCloseAccount = async () => {
	return await httpClient.get<ExistPendingCloseAccountResponse>("/users/exist-pending-close-account");
}

export const closeAccount = async () => {
	return await httpClient.post<CloseUserAccountResponse>("/users/close-account");
}

export const confirmOrRejectCloseUserAccount = async (model: ConfirmOrRejectCloseUserAccountRequest, action: "confirm" | "reject") => {
	try {
		const { data } = await httpClient.post<ConfirmOrRejectCloseUserAccountResponse>(`/users/close-account/${action}`, model);
		return data;
	} catch (e: any) {
		throw e.response || e;
	}
}